import React, { useState, useContext } from "react";
import "../../../Style/pagestyle.scss";
import {
  Box,
  Button,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useQuery } from "@apollo/client";
import moment from "moment";
//src
import { AuthContext } from "../../../Context/AuthContext";
import EmptyData from "../../Include/EmptyData";
import LoadingPage from "../../Include/LoadingPage";
import CreateDriverLicense from "./CreateDriverLicense";
import DriverLicenseAction from "./DriverLicenseAction";
import { GET_DRIVERLICENSE_BY_STAFF } from "../../../Schema/StaffDriverLicense";

export default function DriverLicense({ userLogin, staffId }) {
  const [loading, setLoading] = useState(true);
  const { setAlert } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  //query
  const [tableData, setTableData] = useState([]);

  const { data, refetch } = useQuery(GET_DRIVERLICENSE_BY_STAFF, {
    variables: {
      staffId: staffId,
    },
    onCompleted: ({ getDrivingLincenseByStaffId }) => {
      setTableData(getDrivingLincenseByStaffId);
      setLoading(false);
    },
    onError: (error) => {
      setAlert(true, "error", error?.message);
      // console.log(error)
    },
  });

  //===================== Resize width Screen=====================
  const [width, setWidth] = React.useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  React.useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div className="page-container">
      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableCell className="header-title-start"> N°</TableCell>
              <TableCell className="header-title">Driving Id</TableCell>
              <TableCell className="header-title">Manual Or Auto</TableCell>
              <TableCell className="header-title">Driving Type</TableCell>
              <TableCell className="header-title">Issue Date</TableCell>
              <TableCell className="header-title">Expiry Date</TableCell>
              <TableCell className="header-title">Remark</TableCell>
              <TableCell
                className="header-title-end header-sticky-right"
                align="right"
              >
                {userLogin?.systemAccessData?.role === "Admin" ? (
                  <Button
                    startIcon={<AddCircleIcon />}
                    className="btn-add-list"
                    onClick={handleOpen}
                  >
                    Add
                  </Button>
                ) : null}
                <CreateDriverLicense
                  open={open}
                  handleClose={handleClose}
                  dialogTitle={"Create"}
                  staffId={staffId}
                  setRefetch={refetch}
                />
              </TableCell>
            </TableHead>
            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row-gray">
                  <TableCell className="body-cell" colSpan={8}>
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <TableBody className="body">
                {tableData?.length === 0 ? (
                  <TableRow className="body-row-gray">
                    <TableCell className="body-cell" colSpan={8}>
                      <EmptyData />
                    </TableCell>
                  </TableRow>
                ) : (
                  <>
                    {tableData?.map((row, index) => {
                      return (
                        <TableRow
                          className={
                            (index + 1) % 2 === 0 ? "body-row" : "body-row-gray"
                          }
                          key={index}
                        >
                          <TableCell className="body-cell-start">
                            {index + 1}
                          </TableCell>
                          <TableCell className="body-cell">
                            {row?.drivingId}
                          </TableCell>
                          <TableCell className="body-cell">
                            {row?.manualOrAuto}
                          </TableCell>
                          <TableCell className="body-cell">
                            {row?.drivingType}
                          </TableCell>
                          <TableCell className="body-cell">
                            {moment(row?.issueDate).format("DD-MM-YYYY")}
                          </TableCell>
                          <TableCell className="body-cell">
                            {moment(row?.expiryDate).format("DD-MM-YYYY")}
                          </TableCell>
                          <TableCell className="body-cell">
                            {row?.remark}
                          </TableCell>
                          <TableCell
                            className="body-cell-end cell-sticky-right"
                            align="right"
                          >
                            <DriverLicenseAction
                              editData={row}
                              setRefetch={refetch}
                              userRole={userLogin?.systemAccessData?.role}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </>
                )}
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </Box>
    </div>
  );
}
